import React, { Component } from 'react'
import LoadingOverlay from '../../components/loading/loading';
import service from "../../services/service";
import { toast } from "react-toastify";

class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            subject: '',
            lastname: '',
            notes: '',
            loading: false,
            error: {}
        };
    }

    changeHandler = (e) => {
        const error = this.state.error;
        error[e.target.name] = ''

        this.setState({
            [e.target.name]: e.target.value,
            error
        })
    }

    subimtHandler = async (e) => {
        e.preventDefault();

        const { name, email, subject, lastname, notes, error } = this.state;

        if (name === '') { error.name = "Please enter your name"; }
        if (email === '') { error.email = "Please enter your email"; }
        if (subject === '') { error.subject = "Please enter your subject"; }
        if (lastname === '') { error.lastname = "Please enter your Lastname"; }
        if (notes === '') { error.notes = "Please enter your message"; }
        if (error) { this.setState({ error }) }

        if (error.name === '' && error.email === '' && error.email === '' && error.lastname === '' && error.subject === '' && error.notes === '') {
            this.setState({ name: '', lastname: '', email: '', subject: '', notes: '', error: {} })
        }
        this.setState({ loading: true });
        try {
            const payload = { name, lastname, subject, email, notes };
            const response = await service.save(payload, "auth/customer-support", "POST");
            if (response && !response.success) {
                toast.error(response.message);
                return;
            }
            toast.success(response.message);
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { name, email, subject, lastname, error, notes, loading } = this.state;

        return (
            <>
                {loading && <LoadingOverlay />}
                <form onSubmit={this.subimtHandler} className="contact-form">
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <div className="form-field">
                                <input value={name} onChange={this.changeHandler} type="text" name="name" placeholder="First Name" />
                                <p>{error.name ? error.name : ''}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-field">
                                <input value={lastname} onChange={this.changeHandler} type="text" name="lastname" placeholder="Lastname" />
                                <p>{error.lastname ? error.lastname : ''}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-field">
                                <input onChange={this.changeHandler} value={email} type="email" name="email" placeholder="Email" />
                                <p>{error.email ? error.email : ''}</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="form-field">
                                <input onChange={this.changeHandler} value={subject} type="text" name="subject" placeholder="Subject" />
                                <p>{error.subject ? error.subject : ''}</p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-field">
                                <textarea onChange={this.changeHandler} value={notes} name="notes" placeholder="Message"></textarea>
                                <p>{error.notes ? error.notes : ''}</p>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="form-submit">
                                <button type="submit" className="theme-btn">Send Message</button>
                            </div>
                        </div>
                    </div>
                </form>
            </>
        )
    }

}
export default ContactForm;